<template>
  <a-modal
    ref="importData"
    title="导入"
    :visible="excelVisible"
    :maskClosable="false"
    @cancel="close"
    @ok="confirmValidate"
    :confirmLoading="isLoading"
  >
    <a-upload-dragger
      class="w200 h200"
      name="file"
      accept=".xlsx, .xls"
      :multiple="true"
      :headers="upload.headers"
      :action="upload.url + '?updateSupport=' + upload.updateSupport+'&versionCode=' + this.sopDfcBasicDataId"
      @change="importExcelHandleChange"
    >
      <p class="ant-upload-drag-icon">
        <a-icon type="inbox" />
      </p>
      <p class="ant-upload-text">请将文件拖拽到此处上传</p>
      <p class="ant-upload-hint">支持单个或批量上传，也可以点击后选择文件上传</p>
    </a-upload-dragger>
  </a-modal>
</template>

  <script>
import Cookies from 'js-cookie'

// 表单字段
export default {

  props: {
    url: {
      type: String,
      default: () => {
        return ''
      }
    },
    sopDfcBasicDataId: {
      type: String,
      default: () => {
        return ''
      }
    }
  },
  data () {
    const url = this.url
    const token =
      process.env.NODE_ENV === 'development' || localStorage.getItem('isFromSystemLogin') === 'true'
        ? localStorage.getItem('token')
        : Cookies.get('Admin-Token')
    const Authorization = token ? 'Bearer ' + token : undefined
    return {
      isLoading: false,
      // 表单校验
      inputType: 2,
      mode: ['month', 'month'],
      // 导入excel
      excelVisible: false,
      // 用户导入参数
      upload: {
        // 是否显示弹出层（用户导入）
        open: false,
        // 弹出层标题（用户导入）
        title: '导入Excel',
        // 是否禁用上传
        isUploading: false,
        // 是否更新已经存在的用户数据
        updateSupport: 0,
        // 设置上传的请求头部
        headers: { Authorization: Authorization },
        // 上传的地址
        url: process.env.VUE_APP_API_BASE_URL + url,
        sopDfcBasicDataId: ''
      }
    }
  },
  created () {},
  methods: {
        /** 导入excel */
   importExcelHandleChange (info) {
      const status = info.file.status
      if (status !== 'uploading') {
      }
      if (status === 'done') {
        if (info.file.response.code === 200) {
          this.$message.success(`${info.file.name}: ${info.file.response.msg}`)
        } else {
          this.$message.error(`${info.file.name}: ${info.file.response.msg}`)
        }
      } else if (status === 'error') {
        this.$message.error(`${info.file.name}: ${info.file.response.msg}`)
      }
    },
    show () {
      // this.addLine()
      this.excelVisible = true
    },
    // 关闭模态框
    close () {
      // this.reset()
      this.excelVisible = false
    },
    confirmValidate () {
        this.excelVisible = false
    }

  }
}
</script>

  <style scoped lang="less">
/deep/.ant-select {
  width: 150px;
}

.rp-width {
  width: 200px;
}
.ip-width {
  width: 150px;
}
</style>
